import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/cn";

// Linear-style chip: soft tinted bg, no border, lowercase, rounded-full.
// The previous "bordered uppercase" treatment read very Fluent/Office.
const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2 h-5 text-xs font-medium",
  {
    variants: {
      tone: {
        neutral:    "bg-muted text-muted-foreground",
        active:     "bg-success/15 text-success",
        draft:      "bg-info/15 text-info",
        deprecated: "bg-muted text-muted-foreground",
        danger:     "bg-danger/15 text-danger",
        warning:    "bg-warning/15 text-warning",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export const Badge = ({ className, tone, ...props }: BadgeProps) => (
  <span className={cn(badgeVariants({ tone }), className)} {...props} />
);
